import { Helmet } from "react-helmet";
import Footer from "../components/Footer";
import Navbar from "../components/Navbar";
import Terminal from "../components/Terminal";
import TerminalLeftTabs from "../components/TerminalLeftTabs";
import "../styles/terminalMain.css";

const TerminalMain = () => {
  return (
    <>
      <Helmet>
        <title>_terminal | Mert Arinci</title>
      </Helmet>
      <div id="projects">
        <Navbar activePage={"terminal"} />

        <div className="terminal-content">
          <TerminalLeftTabs />
          <Terminal />
        </div>
        <Footer />
      </div>
    </>
  );
};

export default TerminalMain;
